var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsiAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 24C21.1667 22.7878 22.7516 23.264 23.591 22.4246C24.4305 21.5851 23.9545 20 25.1667 20C26.3789 20 25.984 21.5851 26.8235 22.4246C27.663 23.264 29.1667 22.7878 29.1667 24C29.1667 25.2122 27.663 24.8176 26.8235 25.6571C25.984 26.4965 26.3789 28 25.1667 28C23.9545 28 24.4305 26.4965 23.591 25.6571C22.7516 24.8176 21.1667 25.2122 21.1667 24Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 59C50.1667 58.3939 50.9591 58.632 51.3788 58.2123C51.7986 57.7926 51.5606 57 52.1667 57C52.7728 57 52.5754 57.7926 52.9951 58.2123C53.4148 58.632 54.1667 58.3939 54.1667 59C54.1667 59.6061 53.4148 59.4088 52.9951 59.8285C52.5754 60.2483 52.7728 61 52.1667 61C51.5606 61 51.7986 60.2483 51.3788 59.8285C50.9591 59.4088 50.1667 59.6061 50.1667 59Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 18C29.1667 17.3939 29.9591 17.632 30.3788 17.2123C30.7986 16.7926 30.5606 16 31.1667 16C31.7728 16 31.5754 16.7926 31.9951 17.2123C32.4148 17.632 33.1667 17.3939 33.1667 18C33.1667 18.6061 32.4148 18.4088 31.9951 18.8285C31.5754 19.2483 31.7728 20 31.1667 20C30.5606 20 30.7986 19.2483 30.3788 18.8285C29.9591 18.4088 29.1667 18.6061 29.1667 18Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1667 57.625C51.4267 57.625 51.8467 20 40.9567 20C33.8916 20 31.8916 33 30.4267 39.645",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1667 31C59.7149 31 56.6898 33.661 54.268 37.3385",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5017 57.625C21.6717 57.625 24.6717 53.375 27.1417 48.315",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1667 56L61.1667 32",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1667 50.5L56.1667 35",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 53L24.1667 36",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1667 43.445L40.1667 21",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1667 57.5L40.1667 49",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1667 43L46.1667 24",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 47L34.1667 26",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9017 56.945L18.9017 32.445",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 31C29.2158 31 28.7856 58 39.9399 58C44.3307 58 46.8608 54.4544 49.1667 50.4152",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsiAnalysis);
export default __webpack_public_path__ + "static/media/msi_analysis.aceac4145be425a1c04b8e391ca7d3a4.svg";
export { ForwardRef as ReactComponent };